import { createSlice } from '@reduxjs/toolkit';
import { ordersData } from '../../data/ordersData';

const initialState = {
  orders: ordersData,
  loading: false,
  error: null,
  searchTerm: '',
  selectedOrder: null,
};

const ordersSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    setOrders: (state, action) => {
      state.orders = action.payload;
    },
    updateOrderStatus: (state, action) => {
      const { orderId, status } = action.payload;
      const index = state.orders.findIndex(order => order.id === orderId);
      if (index !== -1) {
        state.orders[index].status = status;
      }
    },
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
    },
    setSelectedOrder: (state, action) => {
      state.selectedOrder = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const {
  setOrders,
  updateOrderStatus,
  setSearchTerm,
  setSelectedOrder,
  setLoading,
  setError,
} = ordersSlice.actions;

export default ordersSlice.reducer;